import { Component } from 'react';
import classnames from 'classnames';
import classNames from 'classnames/bind';
import Button from 'components/atoms/button/index.jsx';

import styles from './styles.scss';

let cx = classNames.bind(styles);

export default class FormActions extends Component {
  render() {
    const { back, postList } = this.props;

    let className = cx({
      formActions: true,
      postList: postList,
    });

    return (
      <div className={classnames(className)}>
        {back && (
          <div className="back">
            <Button buttonText="Volver" type="back" onClick={() => back()} />
          </div>
        )}

        {this.props.children}
      </div>
    );
  }
}
